import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Rtipopservice } from '../../../../services/rtipopservice.service';
import { ReceiptService } from '../../../../services/receipt.service';
import { DocumentService } from '../../../../services/document.service';
import { from, Observable, of, Subject } from 'rxjs';
import { catchError, finalize, mergeMap, takeUntil, tap } from 'rxjs/operators';
import { log } from 'console';
import { PendingImageUpload } from '../../../../models/document-upload.model';

@Component({
  selector: 'add-to-receipt-drop-off-rti',
  templateUrl: './add-to-receipt-drop-off-rti.component.html',
  styleUrls: ['./add-to-receipt-drop-off-rti.component.scss'],
})
export class AddToReceiptDropOffRTIComponent implements OnInit, OnDestroy {
  isVisible = false;
  localShipmentsByCurrencyDO = {};
  @Input() shippmentsRTI = [] as any[];
  shipments: any[] = [];
  hasDropOffShipment: boolean;
  receipt: any;
  isToggled = false;
  webcamCapturedImage: string | null = null;
  showWebcamModal: boolean = false;
  ScannedFile = [];
  shippment = {} as any;
  hasRTIShipment = false;
  damagedCount = 0;
  scannedItems: string[] = [];
  totalDamagedCount: number = 0;
  ItemNumber: string[] = [];
  missingItems: string[] = [];
  damagedItemsArray: string[] = [];
  Status: [] = [];
  damagedGroupedByShipment = [];
  mismatchesDamagedvsImages: string[] = [];
  missmatches: string[] = [];
  totalCaptured = 0;
  totalAttempts = 0;
  uploadMessage = '';
  ImagesArray: string[] = [];
  PendingImages : PendingImageUpload[] = [];
  isUploading: boolean;
  uploadProcessedCount = 0;
  uploadSuccessCount = 0;
  uploadFailedCount = 0;
  uploadCompleted = false;
  activeWebcam: { sIndex: number; iIndex: number } | null = null;
  private triggerSubject = new Subject<void>();
  private strictShipmentItemNumbers: Set<string> = new Set();
  private discrepancyNotAllowedItemsMap: Map<string, number> = new Map();

  private destroy$ = new Subject<void>();
  @Output() onRTIShipment = new EventEmitter<{ hasRTIShipment: boolean; RTIShipments: any[]; damagedItems: boolean; Status: any[] }>();
  @Output() dropoffShipments = new EventEmitter();
  @Output() addToReceipt = new EventEmitter();
  branchCurrencyCode: string = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
  triggerObservable: Observable<void> = this.triggerSubject.asObservable();
  


  constructor(private popupService: Rtipopservice, private receiptService: ReceiptService, private documentService: DocumentService) { }

  ngOnInit() {
    this.popupService.showPopup$.subscribe(() => {
      this.isVisible = true;
      this.getRTIShipmentDetails(this.shippmentsRTI);
      console.log('Current RTI shipments:', this.shippmentsRTI);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    console.log('Component destroyed');
  }

  getRTIShipmentDetails(shipments) {
    let ShipmentNumbers = shipments.map(s => s.Number).join(',');
    this.receiptService.getDropOffRTIShipmentDetails(ShipmentNumbers, 4, (res) => {
      this.shipments = res;
      res.forEach(shipment => {
        shipment.isToggled = this.isToggled;
        shipment.scannedItems = [];
        this.ItemNumber.push(shipment.ItemNumber);
        shipment.ItemsList.forEach(item => {
          item.scannedCount = 0;
          item.scannedList = [];
        });
      });
      console.log('Fetched RTI shipment details:', this.shipments);

    }, (err) => {
      console.error('Error fetching drop-off RTI shipment details:', err);
    });
  }

  //#region  Discrepancy Logic
  addToReceiptClick() {
    this.strictShipmentItemNumbers = new Set(
      this.shipments
        .filter(s => !s.AllowsDiscrepancies)
        .flatMap(s => s.ItemsList.map(item => item.ItemNumber))
    );

    this.discrepancyNotAllowedItemsMap = this.shipments
      .filter(s => !s.AllowsDiscrepancies)
      .flatMap(s => s.ItemsList)
      .reduce((map, item) => {
        const key = item.ItemNumber;
        map.set(key, (map.get(key) || 0) + Number(item.Pieces));
        return map;
      }, new Map<string, number>());

    const damaged = this.damagedvsImages();
    this.mismatchesDamagedvsImages = damaged;

    if (damaged.length > 0) {
      return;
    }
    else {
      this.discrepancyValuelogic();
    }
  }

  discrepancyValuelogic() {
    if (this.discrepancyNotAllowedItemsMap.size === 0) {
      this.addToReceiptRTI();
    } else {
      this.missmatches = this.scannedVSActual();
      if (this.missmatches.length === 0) this.addToReceiptRTI();
      this.ngOnDestroy();
    }
  }

    createDamagedGroupedByShipment(): DamagedShipment[] {
    this.damagedGroupedByShipment = this.shipments.map(shipment => {
      const damagedItems = shipment.ItemsList
        ?.filter(item => Number(item.damagedCount) > 0)
        .map(item => ({
          ItemNumber: item.ItemNumber,
          damagedItemsCount: item.damagedCount
        })) || [];

      console.log('Checking Damaged Items for Shipment:', damagedItems);
      if (damagedItems.length === 0) return null;

      console.log(`Shipment ${shipment.Waybill_No} has damaged items:`, damagedItems, `Total damaged count: ${this.damagedCount}`);
      console.log('Current damaged items array:', this.damagedGroupedByShipment);

      return damagedItems.map(damagedItem => ({
        Waybill_No: shipment.Waybill_No,
        ItemNumber: damagedItem.ItemNumber,
        damagedItemsCount: damagedItem.damagedItemsCount
      }));
    }).filter(Boolean) as DamagedShipment[];

    return this.damagedGroupedByShipment;
  }

  updateTotalDamagedCount() {
    let total = 0;

    this.damagedItemsArray = this.shipments.flatMap(shipment =>
      shipment.ItemsList
        ?.filter(item => Number(item.damagedCount) > 0)
        .map(item => {
          total += Number(item.damagedCount) || 0;
          return item.ItemNumber;
        }) || []
    );
    this.totalDamagedCount = total;
  }

  addToReceiptRTI() {
    if (this.shipments.length > 0) {
      this.hasRTIShipment = true;
    } else {
      this.hasRTIShipment = false;
    }
    this.onRTIShipment.emit(
      {
        hasRTIShipment: this.hasRTIShipment,
        RTIShipments: this.shipments,
        damagedItems: this.damagedItemsArray.length > 0 ? true : false,
        Status: this.statusScannedVsActual()
      });
  }
  //#endregion

  //#region Scanned Items Logic
  //Scanned Items Logic
  scannedItemsList(awb) {
    if (!this.scannedItems.includes(awb)) {
      this.scannedItems.push(awb);
    }
  }

  onScan(barcode: string) {
    if (!barcode || !barcode.trim()) return;

    let found = false;
    this.shipments.forEach(shipment => {
      shipment.ItemsList.forEach(item => {
        if (item.ItemNumber === barcode) {
          item.scannedCount++;
          item.scannedList.push(barcode);
          shipment.scannedItems.push(barcode);
          found = true;
        }
      });
    });

    if (!found) {
      console.warn('Scanned item not found:', barcode);
    }
    this.scannedItems.push(barcode);
  }
  //damaged vs images
  damagedvsImages() {
    this.mismatchesDamagedvsImages = this.damagedItemsArray.filter(item => !this.ImagesArray.includes(item));
    return this.mismatchesDamagedvsImages.length ? this.mismatchesDamagedvsImages : [];
  }

  resetItemScan(shipment: any, item: any): void {
    if (!shipment || !item) return;
  
    const itemNumber = item.ItemNumber;
  
    item.scannedCount = 0;
    item.scannedList = [];
  
    shipment.scannedItems = (shipment.scannedItems || [])
      .filter(x => x !== itemNumber);
  
    this.scannedItems = (this.scannedItems || [])
      .filter(x => x !== itemNumber);
  
    this.missmatches = [];
  }

  //scanned vs actual 
  scannedVSActual(): string[] {
    // Filter scanned items to ONLY those belonging to strict (non-discrepancy) shipments
    const relevantScanned = (this.scannedItems || [])
      .filter(item => item?.trim() && this.strictShipmentItemNumbers.has(item.trim()));

    console.log('Expected (strict shipments):', Object.fromEntries(this.discrepancyNotAllowedItemsMap));
    console.log('Relevant scanned items:', relevantScanned);

    // Count relevant scanned items
    const scannedCount = relevantScanned.reduce((map, item) => {
      map.set(item, (map.get(item) || 0) + 1);
      return map;
    }, new Map<string, number>());

    console.log('Scanned item counts (strict shipments):', Object.fromEntries(scannedCount));

    const missingInScanned: string[] = [];
    const extraInScanned: string[] = [];

    // Find missing
    this.discrepancyNotAllowedItemsMap.forEach((expectedQty, item) => {
      const scannedQty = scannedCount.get(item) || 0;
      if (scannedQty < expectedQty) {
        missingInScanned.push(...Array(expectedQty - scannedQty).fill(item));
      }
    });

    // Find extra
    scannedCount.forEach((scannedQty, item) => {
      const expectedQty = this.discrepancyNotAllowedItemsMap.get(item) || 0;
      if (scannedQty > expectedQty) {
        extraInScanned.push(...Array(scannedQty - expectedQty).fill(item));
      }
    });

    return [...missingInScanned, ...extraInScanned];
  }

  //Scanned vs Actual 
  statusScannedVsActual(): any[] {
    let result: any[] = [];
    const damagedItems = this.createDamagedGroupedByShipment().flat();

    console.log('damagedItems from createDamagedGroupedByShipment is:', damagedItems);

    this.shipments.forEach((shipment, index) => {

      console.log(`Shipment ${index + 1}:`, shipment.Waybill_No);

      let shipmentNumber = shipment.Waybill_No;

      shipment.ItemsList?.forEach(item => {

        let itemNumber = item.ItemNumber;
        let piecesActual = Number(item.Pieces || 0);
        let status = '';
        let piecesScanned = this.scannedItems?.filter(x => x === itemNumber).length || 0;
        const damagedItemCount = damagedItems.find(x => x.ItemNumber === itemNumber)?.damagedItemsCount ?? 0;

        console.log('damagedItemCount:', damagedItemCount, 'for ItemNumber:', itemNumber);


        if (this.damagedItemsArray.includes(itemNumber)) {
          result.push({
            shipmentNumber,
            ItemNumber: itemNumber,
            piecesScanned,
            piecesActual,
            status: 'Damaged',
            damagedCount: damagedItemCount
          });
        }

        if (piecesScanned === piecesActual) status = 'Match';
        if (piecesScanned < piecesActual) status = 'Shortage';
        if (piecesScanned > piecesActual) status = 'Overage';

        result.push({
          shipmentNumber,
          ItemNumber: itemNumber,
          piecesScanned,
          piecesActual,
          status
        });

        console.log(
          `Item ${itemNumber}: ${piecesScanned} / ${piecesActual} → ${status}`
        );

      });

    });

    console.log('Final scanned vs actual status:', result);
    return result;
  }
  //#endregion

  //#region button actions
  toggleFunction(index) {
    let Shipment = this.shipments

    if (Shipment[index].isToggled) {
      Shipment[index].isToggled = false;
    } else {
      Shipment[index].isToggled = true;
    }
  }

  closeWebcam(sIndex?: number, iIndex?: number) {
    this.activeWebcam = null;
    this.triggerSubject.complete(); // clean up
    this.triggerSubject = new Subject<void>(); // reset for next open
    this.triggerObservable = this.triggerSubject.asObservable();
  }

  openWebcam(sIndex: number, iIndex: number, shipment: any) {
    // Reset subject to clear any stale subscriptions
    this.triggerSubject = new Subject<void>();
    this.triggerObservable = this.triggerSubject.asObservable(); // 🔑 fresh observable each open

    this.activeWebcam = { sIndex, iIndex };
  }

  removeShipment(shipment) {
    var index = this.shippmentsRTI.indexOf(shipment)
    if (index > -1) {
      this.shippmentsRTI = this.shippmentsRTI.filter((x) => x?.Number != shipment?.Number);
    }
  }

  contentOfFile(base64) {
    var Base64 = base64
    var block = Base64.split(";");
    var contentType = block[0].split(":")[1];
    var realData = block[1].split(",")[1];

    return realData;
  }

  isWebcamOpen(sIndex: number, iIndex: number): boolean {
    return (
      this.activeWebcam?.sIndex === sIndex &&
      this.activeWebcam?.iIndex === iIndex
    )
  }

  triggerSnapshot(): void {
    this.triggerSubject.next();
  }

  close() {
    this.isVisible = false;
    this.ngOnDestroy()
  }

  //#endregion

  //#region  Camera Modal Logic
  handleWebcamCapturedImage(base64Image, shipment, item) {
    this.webcamCapturedImage = base64Image;
    this.saveCapturedImage(base64Image, shipment, item)
    // this.ScannedFile = this.contentOfFile(base64Image);
  }

  saveCapturedImage(data: string , shipment: any, item: any) : void {
    const fileContent  = this.contentOfFile(data);
    const timestamp = Date.now();
    const fileName = `${item.ItemNumber}_DamagedItem_${timestamp}.png`;

    const pendingImage: PendingImageUpload = {
      fileName,
      fileContent,
      previewUrl: data,
      shipmentNumber: shipment.Waybill_No,
      itemNumber: item.ItemNumber,
      localId: `${shipment.Waybill_No}_${item.ItemNumber}_${timestamp}`
    };

    this.PendingImages = this.groupPendingImagesByShipment([...this.PendingImages, pendingImage]);
    this.uploadMessage = `Image captured successfully (${this.PendingImages.length}/${this.totalAttempts}/${item.ItemNumber})`;
  }

  removePendingImage(localId: string): void {
    this.PendingImages = this.PendingImages.filter(img => img.localId !== localId);
    this.uploadMessage = this.PendingImages.length
      ? `${this.PendingImages.length} image(s) pending upload`
      : 'No pending images';
  }

  confirmUpload(): void {
    this.resetUploadProgress();
    if (this.isUploading || this.PendingImages.length === 0) {
      return;
    }

    const sourceID = 1;
    const userLocationId = JSON.parse(sessionStorage.getItem('company') || '{}')?.UserLocationId;
    if (!userLocationId) {
      this.uploadMessage = 'Unable to upload: missing user location';
      return;
    }

    const imagesToUpload = [...this.PendingImages];
    const maxConcurrency = 2;
    const succeededLocalIds = new Set<string>();

    this.isUploading = true;
    this.uploadMessage = `Uploading 0/${imagesToUpload.length}…`;

    from(imagesToUpload)
      .pipe(
        mergeMap(
          (image) =>
            this.documentService
              .UploadShipmentDocumentsAsync({
                sourceID,
                reference: image.shipmentNumber,
                userLocationId,
                fileName: image.fileName,
                fileContent: image.fileContent
              })
              .pipe(
                tap((res) => {
                  this.uploadProcessedCount++;
                  const ok = res?.success === true || res?.isSuccessful === true;
                  if (ok) {
                    this.uploadSuccessCount++;
                    this.ImagesArray.push(image.itemNumber);
                    succeededLocalIds.add(image.localId);
                  } else {
                    this.uploadFailedCount++;
                  }
                  this.uploadMessage = `Uploading ${this.uploadProcessedCount}/${imagesToUpload.length} | OK: ${this.uploadSuccessCount} | Failed: ${this.uploadFailedCount}`;
                }),
                catchError(() => {
                  this.uploadProcessedCount++;
                  this.uploadFailedCount++;
                  this.uploadMessage = `Uploading ${this.uploadProcessedCount}/${imagesToUpload.length} | OK: ${this.uploadSuccessCount} | Failed: ${this.uploadFailedCount}`;
                  return of(null);
                })
              ),
          maxConcurrency
        ),
        finalize(() => {
          this.isUploading = false;
          this.uploadCompleted = true;

          this.PendingImages = this.PendingImages.filter((img) => !succeededLocalIds.has(img.localId));

          if (this.uploadFailedCount === 0) {
            this.uploadMessage = `Upload completed: ${this.uploadSuccessCount} succeeded`;
            this.totalCaptured = this.uploadSuccessCount;
          } else if (this.uploadSuccessCount === 0) {
            this.uploadMessage = `Upload failed: ${this.uploadFailedCount} image(s). You can retry with Confirm Upload.`;
          } else {
            this.uploadMessage = `Partial success: ${this.uploadSuccessCount} succeeded, ${this.uploadFailedCount} failed. Failed images stay in the queue.`;
            this.totalCaptured = this.uploadSuccessCount;
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  private resetUploadProgress(): void {
    this.uploadProcessedCount = 0;
    this.uploadSuccessCount = 0;
    this.uploadFailedCount = 0;
    this.uploadCompleted = false;
  }

  private groupPendingImagesByShipment(images: PendingImageUpload[]): PendingImageUpload[] {
    return [...images].sort((a, b) =>
      (a.shipmentNumber || '').localeCompare(b.shipmentNumber || '')
    );
  }
  
  //#endregion
}